import { useState, useEffect } from "react";
import axios from "axios";
import Echo from "laravel-echo";
import notify from "../assets/notification.mp3";
import serverPath from "../components/config";

const useOrderData = () => {
  const [newOrders, setNewOrders] = useState([]);
  const [inProgress, setInProgress] = useState([]);
  const [OrderMonthly, setOrderMonthly] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [audio] = useState(new Audio(notify));

  const playAudio = () => {
    audio.load();
    audio.play();
  };

  const fillData = async () => {
    try {
      const [responseOne, responseTwo, responseThree] = await Promise.all([
        axios.get(`${serverPath}/api/new_orders`, {
          headers: {
            Accept: "application/json",
          },
        }),
        axios.get(`${serverPath}/api/inProgress_orders`, {
          headers: {
            Accept: "application/json",
          },
        }),
        axios.get(`${serverPath}/api/order_summery`, {
          headers: {
            Accept: "application/json",
          },
        }),
      ]);


      const newOrdersData = responseOne.data.order;
      const inProgressData = responseTwo.data.order;
      const OrderMonthlyData = responseThree.data.data;
      // console.log(OrderMonthlyData);
      
      setNewOrders(newOrdersData);
      setInProgress(inProgressData);
      setOrderMonthly(OrderMonthlyData);
    } catch (error) {
      console.error("Error fetching data: ", error);
      // Handle error, show alert, etc.
    }
  };
const fetchOrderData = async () => {
  try {
    const response = await fetch(`${serverPath}/api/order_summery`); // Replace with your API endpoint
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const OrderMonthlyData = await response.json();
    console.log(OrderMonthlyData.data);
    
    setOrderMonthly(OrderMonthlyData.data);
    
    // props.updateOrderSummaryList(OrderMonthlyData.data); // Update the order summary list
  } catch (error) {
    console.error('Error fetching order data:', error);
  }
};
  useEffect(() => {
    fillData();
    window.Echo = new Echo({
      broadcaster: "socket.io",
      host: "https://echo.buffet.top2top.net",
    });

    const channel = window.Echo.channel("orders-channel");
    channel.listen(".OrdersEvent", (data) => {
      handleUpdate(data);
    });

    const channelCancel = window.Echo.channel("make-cancel-channel");
    channelCancel.listen(".MakeOrCancelOrder", (data) => {
      handleCancelOrder(data);
    });

    // Clean-up effect
    return () => {
      // Unsubscribe from channels or perform clean-up if needed
    };
  }, []);

  const handleCancelOrder = (data) => {
    playAudio();

    if (data.status === "Cancelled") {
      setNewOrders((prevOrders) =>
        prevOrders.filter((item) => item.id !== data.order_id)
      );
    }
  };

  const handleUpdate = (data) => {
    playAudio();

    if (data.status === "Pending") {
      setNewOrders((prevOrders) => [...prevOrders, data]);
    } else if (data.status === "Completed") {
      setInProgress((prevInProgress) =>
        prevInProgress.filter((item) => item.id !== data.id)
      );
      // fetchOrderData();
    } else {
      setInProgress((prevInProgress) => [...prevInProgress, data]);
      setNewOrders((prevOrders) =>
        prevOrders.filter((item) => item.id !== data.id)
      );
    }
  };

  const deliveredItem = (id) => {
    setInProgress((prevInProgress) =>
      prevInProgress.filter((item) => item.id !== id)
    );
    fetchOrderData();
  };

  const approvedItem = (id) => {
    setNewOrders((prevOrders) => prevOrders.filter((item) => item.id !== id));
  };

  const showErr = (msg) => {
    if (msg) {
      setShowAlert(true);
      setErrMsg(msg);
    }
  };

  const hideErr = () => {
    setShowAlert(false);
  };
  // console.log(OrderMonthly);

  return {
    newOrders,
    inProgress,
    OrderMonthly,
    showAlert,
    errMsg,
    fillData,
    deliveredItem,
    approvedItem,
    showErr,
    hideErr,
    setShowAlert,
  };
};

export default useOrderData;
